module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Substract-14eeb223d376e3c94e339954c4f1ae5e.svg";